import template from './visual-divider.jade';

export default angular
    .module('cian.addForm.priceAndDealTermsDivider', ['cian.addForm.visualDivider'])
    .directive('cianAfPriceAndDealTermsVisualDivider', () => ({
        template,
    }))
    .name;
